import { ORDER_BY_NUMBER_QUERY_PARAM, ORDER_BY_STRING_QUERY_PARAM } from 'src/modules/common/constants';
import { Filter } from 'src/utils/composeFilter';

export const getSearchParams = (searchParams: URLSearchParams) => (newFilter: Filter) => {
    const newSearch = new URLSearchParams();
    Object.entries(newFilter).forEach(([name, value]) => {
        if (value.length > 0) {
            newSearch.set(name, JSON.stringify(value));
        }
    });
    newSearch.delete(ORDER_BY_NUMBER_QUERY_PARAM);
    newSearch.delete(ORDER_BY_STRING_QUERY_PARAM);
    const input = searchParams.get('input');
    if (input) {
        newSearch.set('input', input);
    }
    return newSearch;
};
